export default __webpack_public_path__ + "static/media/eveningsnacks.25fe92e1.svg";